import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  notificationCount: 0,
};
const countSlice = createSlice({
  name: 'count',
  initialState: initialState,
  reducers: {
    setNotificationCount: (state, action) => {
      state.notificationCount = action.payload;
    },
  },
});

export const {setNotificationCount} = countSlice.actions;
const countReducer = countSlice.reducer;
export default countReducer;
